import * as yup from "yup";

const ReferralPartnerRegistrationSchema = yup.object().shape({
    companyName: yup
        .string()
        .required('Please Enter Company Name'),
    address: yup
        .string()
        .required('Please Enter Address'),
    city: yup
        .string()
        .required('Please Enter City'),
    state: yup
        .string()
        .length(2, 'State must be 2 characters')
        .required('Please Enter State'),
    zip: yup
        .string()
        .length(5, 'Zip Code must be 5 digits')
        .matches(/^\d{5}$/, 'Zip must be 5 digits')
        .required('Please Enter Zip Code'),
    phone: yup
        .string()
        .matches(/^[0-9]+$/, "Phone number can only contain digits")
        .transform((value) => value.replace(/[^0-9]/g, ''))
        .length(10, 'Phone must be exactly 10 digits')
        .required('Please Enter Phone Number'),
    email: yup
        .string()
        .email("Please enter a valid email!")
        .required("Please Enter Email"),
    password: yup
        .string()
        .min(8, "Password must be longer than 8 characters")
        .required("Password is required"),
    representativeName: yup
        .string()
        .required('Please enter representative\'s name'),
    websiteURL: yup
        .string()
        .required('Please enter webiste link'),
    reasonForPartnership: yup
        .string(),
    sourceOfClients: yup
        .string()
        .required('Please enter your source of clients'),
    clientsPerMonth: yup.string(),
    howDidYouHear: yup.string(),
    expectations: yup.string(),
    references: yup.string(),
});

export default ReferralPartnerRegistrationSchema;